module.exports = __webpack_public_path__ + "img/1478522189.8f01d699.jpg";